import { NavigateBackLink } from '@exam-center/components';
import { Flex, PageHeader, Text } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { useAdminProctorDetails, type Proctor } from '../../providers';

function getAdminProctorHeaderDetails(proctor: Proctor) {
  const fullName = [proctor.titleTh, proctor.firstNameTh, proctor.middleNameTh, proctor.lastNameTh]
    .filter(Boolean)
    .join(' ');

  const examCenter = proctor.examCenterCode;
  const createdAt = formatDateTime(proctor.createdAt);

  const updatedAt = formatDateTime(proctor.updatedAt);
  const updatedBy =
    proctor.updatedUser?.firstname && proctor.updatedUser?.lastname
      ? `${proctor.updatedUser.firstname} ${proctor.updatedUser.lastname}`
      : '-';

  return { fullName, examCenter, createdAt, updatedAt, updatedBy };
}

export default function AdminProctorDetailsHeader() {
  const { proctor } = useAdminProctorDetails();
  const { fullName, examCenter, createdAt, updatedAt, updatedBy } =
    getAdminProctorHeaderDetails(proctor);

  return (
    <PageHeader
      title={fullName}
      subtitleSection={
        <Flex
          sx={{
            justifyContent: 'space-between',
            flex: 1,
          }}
        >
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(4),
            })}
          >
            <Text variant='body2' color='text.secondary'>
              ศูนย์ทดสอบ: {examCenter}
            </Text>
            <Text variant='body2' color='text.secondary'>
              วันที่อนุมัติคำขอ: {createdAt}
            </Text>
          </Flex>
          <Flex
            sx={(theme) => ({
              gap: theme.spacing(4),
            })}
          >
            <Text variant='body2' color='text.secondary'>
              Last Updated: {updatedAt}
            </Text>
            <Text variant='body2' color='text.secondary'>
              By: {updatedBy}
            </Text>
          </Flex>
        </Flex>
      }
      linkAdornment={<NavigateBackLink to='/admin/exam-proctors/proctors' />}
    />
  );
}
